import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import LoginIcon from '@mui/icons-material/Login';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
import { ContextData } from '../../context/Context';
import { Getrequest } from '../../context/AxiosRequest';






const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));



export default function Header() {

        
    
    const Navigate = useNavigate();
    const {accesstoken,setaccesstoken,setUserTokens} = React.useContext(ContextData)
        
    const HandleLogout = async()=>{

       const response = await Getrequest("/auth/logout",accesstoken)
       Navigate("/home")
       setaccesstoken(null)
       setUserTokens("")
       toast.success("Logout")
       
          
  }


  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
       >

      <MenuItem onClick={()=> Navigate("/application/update_login_detail")}>Update Login Details</MenuItem>
      <MenuItem onClick={()=>Navigate("/application/student_support")}>Student Support</MenuItem>

      </Menu>


  );

  

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (

    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      >

    {/*   <MenuItem onClick={()=> Navigate("/application/home")}>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">

            <HomeIcon />
        </IconButton>
        <p>Home</p>
      </MenuItem> */}
     {/*  <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
          onClick={HandleLogout}
        >
        
            <LoginIcon />
       
        </IconButton>
        <p>Logout</p>
      </MenuItem> */}
     {/*  <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem> */}




    </Menu>


  );


  
  return (
    <Box sx={{ flexGrow: 1, }}>
      <AppBar sx={{height:"80px", backgroundColor:"white",color:"black" }} elevation={8} position="static">
        <Toolbar>
        
         <img 
          className="w-20 sm:w-20 md:w-20 h-auto rounded-md shadow-sm"
          alt="KADSSLB LOGO"
          src="/assets/newksslb-tp.png"
         />
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: '', sm: 'block' } }}
          >
             KADSSLB Application Portal
          </Typography>
         
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>


           

            <IconButton onClick={()=> Navigate("/home")} size="large" aria-label="show 4 new mails" color="inherit">
            
            <HomeIcon />
             
            </IconButton>

          {/*   <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton> */}


          {/*      <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              onClick={HandleLogout}
            >
          
                <LoginIcon />
          
            </IconButton> */}

          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>

          </Box>
        </Toolbar>
      </AppBar>
{/*       {renderMobileMenu}
      {renderMenu} */}
    </Box>
  );



}





/* 

<div className="flex items-center justify-between w-full px-4 py-2">

  <div className="flex items-center gap-3">
    <img
      className="w-20 sm:w-20 md:w-20 h-auto rounded-md shadow-sm"
      alt="KADSSLB LOGO"
      src="/assets/newksslb.jpg"
    />
    <div className="hidden sm:block">
      <h1 className="text-sm sm:text-base font-bold text-slate-800">
        KADSSLB Application Portal
      </h1>
      <p className="text-xs text-slate-500">{formattedDate}</p>
    </div>
  </div>


  <div className="flex items-center gap-3 flex-wrap justify-center">
    {location.pathname !== "/application/home" && (
      <Button
        className="Hover-"
        onClick={handleNextPageToSettings}
        sx={{
          whiteSpace: "nowrap",
          fontSize: "14px",
          backgroundColor: "rgb(0, 24, 69)",
          color: "white",
          fontWeight: 600,
          textTransform: "none",
          padding: "6px 14px",
          "&:hover": { backgroundColor: "rgb(0, 40, 120)" },
        }}
        size="medium"
        variant="contained"
      >
        <KeyboardBackspaceIcon sx={{ fontSize: "18px", mr: 0.5 }} /> Back
      </Button>
    )}

    <Button
      className="Hover-"
      onClick={HandleLogout}
      sx={{
        whiteSpace: "nowrap",
        fontSize: "14px",
        backgroundColor: "#b91c1c",
        color: "white",
        fontWeight: 600,
        textTransform: "none",
        padding: "6px 14px",
        "&:hover": { backgroundColor: "#991b1b" },
      }}
      size="medium"
      variant="contained"
    >
      Logout
    </Button>
  </div>


  <img
    className="w-20 sm:w-24 md:w-20 h-auto rounded-md shadow-sm"
    alt="KADSSLB LOGO"
    src="/assets/dbimgs/kd.png"
  />
</div>



*/